import { render } from "./TheListOfChannels.vue?vue&type=template&id=a069dcf2&ts=true"
import script from "./TheListOfChannels.vue?vue&type=script&lang=ts"
export * from "./TheListOfChannels.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__